<template>
  <section class="inscription">
    <div>
      <individual-form v-if="isIndividual" />
      <pro-form v-else />
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      isIndividual: true,
    };
  },
  components: {
    IndividualForm: () => import(/* webpackChunkName: "createaccount"  */ `./Individual/IndividualForm`),
    ProForm: () => import(/* webpackChunkName: "createaccount"  */ `./Pro/ProForm`),
  },
  mounted() {
    this.isProOrParticulier();
  },

  methods: {
    isProOrParticulier() {
      this.isIndividual = window.renaultRent.register.type <= 1
    },
  },
};
</script>

<style lang="scss" scoped>

.inscription {
  display: flex;
  flex: 1;
  justify-content: center;
  margin-bottom: 30px;
  padding: 0 30px;

  @include teq-breakpoint($wide) {
    padding: 0;
  }

  h1 {
    color: $black;
    font-family: $f-graphie-bold;
    margin: 20px 0;
    padding: 0 30px;
    text-transform: uppercase;

    @include teq-breakpoint($wide) {
      padding: 0;
    }

    @include font-size(20px);
  }

  &__row {
    display: flex;
    flex: 1;
    width: 100%;

    @include teq-breakpoint($medium) {
      max-width: calc(100% - 186px);
    }

    > li {
      align-content: flex-start;
      display: flex;
      flex: 1;
      flex-direction: column;

      @include teq-breakpoint($wide) {
        &:nth-child(odd) {
          margin-right: 10px;
        }

        &:nth-child(even) {
          margin-left: 10px;
        }
      }
    }

    > section {
      align-content: flex-start;
      display: flex;
      flex: 1;
      margin-bottom: 20px;
    }

    @include teq-breakpoint($wide) {
      flex-direction: row;
    }
  }
}
</style>
